import { gql } from "apollo-boost";
export const CREATE_USER = gql`
  mutation CreatePerson(
    $clientId: Int
    $protocol: String
    $initialThreadId: Int
    $externalOrg: String
  ) {
    createPerson(
      clientId: $clientId
      protocol: $protocol
      initialThreadId: $initialThreadId
      externalOrg: $externalOrg
    ) {
      person {
        personId
        firstName
        lastName
        sessionToken
        sessionTokenExpiry
        idHash
      }
      response {
        string
        metadata
      }
    }
  }
`;
export const TALK_TO_BOT = gql`
  mutation TalkToBot($personId: String, $personMessage: String) {
    talkToBot(personId: $personId, personMessage: $personMessage) {
      response {
        string
        metadata
        threadButton {
          title
          contentType
          payload
        }
      }
    }
  }
`;
export const PING_USER = gql`
  mutation PingPerson($personId: Int, $target: String) {
    pingPerson(personId: $personId, target: $target) {
      response {
        string
        metadata
        threadId
      }
    }
  }
`;
export const REFRESH_TOKEN = gql`
  mutation generateSessionToken($personId: String) {
    generateSessionToken(personId: $personId) {
      person {
        personId
        firstName
        lastName
        sessionToken
        sessionTokenExpiry
        idHash
      }
    }
  }
`;
